// @flow

import Clipboard from 'react-clipboard.js';
import { useCallback, useEffect, useState } from 'react';

export function useCopyToClipboard(): [ Clipboard, bool, ()=> void ] {
  const [copied, setCopied] = useState(false);
  const [timeoutId, setTimeoutId] = useState();

  useEffect(() => {
    return () => clearTimeout(timeoutId);
  }, [timeoutId]);

  const handleCopy = useCallback(() => {
    setCopied(true);
    setTimeoutId(setTimeout(() => setCopied(false), 1500));
  }, [setCopied]);

  return [Clipboard, copied, handleCopy];
}
